import { render, staticRenderFns } from "./PosCashDrawer.vue?vue&type=template&id=4bfd596c&scoped=true"
import script from "./PosCashDrawer.vue?vue&type=script&lang=js"
export * from "./PosCashDrawer.vue?vue&type=script&lang=js"
import style0 from "./PosCashDrawer.vue?vue&type=style&index=0&id=4bfd596c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfd596c",
  null
  
)

export default component.exports